/**
 * "Why?" — the one question every rejection and every request for changes
 * must answer.
 *
 * The server refuses a rejection without a reason (lib/serviceRouting.js), so
 * the dialog does not let one be sent empty either: the person on the other
 * end of the request needs to know what to fix.
 */

import { useEffect, useState } from 'react';
import { Button, Field, Modal, Textarea } from '../../components/common';

export function NoteDialog({
  open,
  onClose,
  onSubmit,
  title,
  label = 'السبب',
  placeholder = '',
  confirmLabel = 'إرسال',
  destructive = false,
  required = true,
  children,
}) {
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) setText('');
  }, [open]);

  const submit = async () => {
    if (required && !text.trim()) return;
    setBusy(true);
    try {
      await onSubmit(text.trim());
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      icon={destructive ? 'alert-triangle' : 'message-square-text'}
      size="sm"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose} disabled={busy}>
            رجوع
          </Button>
          <Button
            variant={destructive ? 'danger' : 'primary'}
            loading={busy}
            disabled={required && !text.trim()}
            onClick={submit}
          >
            {confirmLabel}
          </Button>
        </div>
      }
    >
      {children}
      <Field label={label} required={required}>
        <Textarea rows={4} value={text} onChange={(e) => setText(e.target.value)} placeholder={placeholder} autoFocus />
      </Field>
    </Modal>
  );
}

export default NoteDialog;
